// extracted by mini-css-extract-plugin
export default {"taskModalHeader":"styles_taskModalHeader__kMyfB","heading":"styles_heading__x8okl","headingTemplate":"styles_headingTemplate__qcUfg"};